/*
    The things in the file are tested in lesson_progress_spec.js.  I didn't
    bother moving those specs over to here because I suspect this will be going
    away soon in favor of a switch to optimistic locking.
*/

// This is kind of the opposite of the server-side merge_challenge_scores
// method.  Here, we are defending against the situation where we send out
// a lesson progress save call and then answer some challenges before the call
// returns.  If we're not careful, the return value will blow away our changes
// to the challenge_scores object.
//
// Unimportant edge case: I guess theoretically you could
// still lose the updates that someone makes to a challenge.
// So, if a save call went out, then the user went back to a previous frame and corrected
// some challenges they had gotten wrong before, those new scores could be blown
// away when the save call returned.  This is irrelevant to test lessons though,
// since users can't go back in that case, and that's where scores really matter.
function mergeInLocalChallengeScores(lessonProgress, incomingChallengeScores) {
    Object.keys(lessonProgress.challenge_scores).forEach(key => {
        const score = lessonProgress.challenge_scores[key];
        if (!Object.hasOwn(incomingChallengeScores, key)) {
            incomingChallengeScores[key] = score;
        }
    });
}

function mergeInLocalCompletedFrames(lessonProgress, incomingCompletedFrames) {
    const merged = { ...incomingCompletedFrames, ...lessonProgress.completed_frames };
    Object.keys(merged).forEach(key => {
        incomingCompletedFrames[key] = merged[key];
    });
}

export default function mergeIncomingChanges(lessonProgress, incomingAttrs) {
    incomingAttrs = {
        ...incomingAttrs,

        // We want to replicate what the server does by making sure to never set
        // `complete` or `completed_at` from a truthy value back to a falsey value.
        complete: lessonProgress.complete || incomingAttrs.complete,
        completed_at: lessonProgress.completed_at || incomingAttrs.completed_at,
        // Now that everyone is on strict scoring, we should always honor the best_score
        // from the server for tests and assessments
        best_score:
            (lessonProgress.for_test_lesson || lessonProgress.for_assessment_lesson) && !!incomingAttrs.best_score
                ? incomingAttrs.best_score
                : // Otherwise, still make sure to use the incoming best score if the local one is falsey
                  lessonProgress.best_score || incomingAttrs.best_score,
    };

    // The merge methods apply in all cases.  They add any values that exist locally
    // that do NOT exist in the incoming attrs.  If values exist in the incoming attrs,
    // we keep them.
    mergeInLocalChallengeScores(lessonProgress, incomingAttrs.challenge_scores);
    mergeInLocalCompletedFrames(lessonProgress, incomingAttrs.completed_frames);

    return incomingAttrs;
}
